export enum ROLES_ENUM {
  admin = 'admin',
  developer = 'developer',
  analyst = 'analyst',
  viewer = 'viewer',
}
